module.exports = __webpack_public_path__ + "static/assets/9ade0dfd35c5ffeb56956798cc3c6f36.png";